import React, { useState, useEffect, useContext, useRef } from "react";
import ScreenContext from "../../../context/screen/ScreenContext";
import LocationContext from "../../../context/location/LocationContext";
import nextClass from "./media/NextClass.png";
import "vlitejs/vlite.css";
import Vlitejs from "vlitejs";
import {
  convertTime,
  addToTime,
  timeDiffToLocal,
} from "../../../utils/timeHandlers";
import "./Class.css";
import handleSchedule from "../../../utils/handleSchedule";
import {
  videoValidation,
  updateInvalidLink,
  updateInvalidMashupLink,
  updateInvalidStrengthLink,
  getMashupClass,
} from "../../../utils/videoValidation";

const Class = ({ type, setType, strengthClass }) => {
  const screenContext = useContext(ScreenContext);
  const { screen, workout, getCurrentRoundWorkout, loading, sendScreenStatus } =
    screenContext;

  const locationContext = useContext(LocationContext);
  const { getLocationSchedule, schedule, clearSchedule } = locationContext;
  const TEN_SECONDS =
    "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/DEV_NO_MODIFY/PRODUCTION/10_SEC_COUNDOWN_TIMER.mp4?_t=1749499876";
  const FIVE_MINUTES =
    "https://d2567ph5zp6ttk.cloudfront.net/public/storage/us/ILKB_SCREENS/DEV_NO_MODIFY/PRODUCTION/5_MIN_COUNDOWN_TIMER.mp4?_t=1730398808";
  const LONG_PRESS_DURATION = 2000;
  const [sequence, setSequence] = useState([]);
  const [start, setStart] = useState(false);
  const [comboStart, setComboStart] = useState(false);
  const [newScreen, setNewScreen] = useState(false);
  let classPlayer;
  const [screenDetails, setScreenDetails] = useState({
    countdown: screen?.location?.alternateCountdown
      ? TEN_SECONDS
      : FIVE_MINUTES,
    supportsMct: screen?.location?.mctEnabled,
  });

  const comboInterval = useRef(null);
  const [nextClassTime, setNextClassTime] = useState("");
  const [timeObj, setTimeObj] = useState({});
  const [countDownMinutes, setCountDownMinutes] = useState(
    screen?.location?.alternateCountdown ? 0.17 : 5
  );
  const [scheduleObj, setScheduleObj] = useState({
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
  });

  const weekDays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const gracePeriodMinutes = 30;

  const timeoutRef = useRef(null);

  // Prevent right clicking
  document.addEventListener("contextmenu", (event) => event.preventDefault());
  // Prevent pausing video
  document.addEventListener("click", (event) => event.preventDefault());

  // Transition to the next video in queue
  const transitionVideo = () => {
    if (sequence && sequence.length > 1) {
      setStart(true);
      const video = document.getElementById("player");
      const updatedSequence = sequence;
      updatedSequence.shift();
      video.src = updatedSequence[0].videoLink;
      setSequence(updatedSequence);
    } else {
      handleStop();
    }
    if (
      sequence.length < 12 &&
      sequence.length > 3 &&
      start &&
      type?.selection !== "Mashup"
    )
      comboEffect();
  };

  // Build the signature class and validate each video link
  const startClass = () => {
    const results = workout.routines;
    const validateResults = [];
    for (let i = 0; i < results.length; i++) {
      videoValidation(results[i])
        .then((res) => {
          validateResults.push({
            videoLink: i === 0 ? screenDetails.countdown : results[i].videoLink,
            order: i,
            validated: res,
          });
        })
        .catch((e) =>
          validateResults.push({
            videoLink: results[i].videoLink,
            order: i,
            validated: e,
          })
        );
    }
    promiseBuffer(validateResults);
  };

  // Build the mashup class and validate each video link
  const startMashupClass = () => {
    const mashupVideoObj = getMashupClass();
    const videos = workout.routines;
    const needsValidation = [
      { videoLink: screenDetails.countdown },
      videos[1],
      videos[2],
      mashupVideoObj,
      videos[11],
      videos[12],
      videos[13],
    ];
    const validateResults = [];
    for (let i = 0; i < needsValidation.length; i++) {
      videoValidation(needsValidation[i])
        .then((res) => {
          validateResults.push({
            videoLink: needsValidation[i].videoLink,
            order: i,
            validated: res,
          });
        })
        .catch((e) =>
          validateResults.push({
            videoLink: needsValidation[i].videoLink,
            order: i,
            validated: e,
          })
        );
    }
    promiseBufferMashup(validateResults);
  };

  // Build the strength class and validate each video link
  const startStrengthClass = () => {
    const strengthVideos = [];
    strengthClass.forEach((s) => {
      strengthVideos.push(s);
    });
    const videos = workout.routines;
    const needsValidation = [
      { videoLink: screenDetails.countdown },
      videos[1],
      videos[2],
      strengthVideos[0],
      strengthVideos[1],
      strengthVideos[2],
      strengthVideos[3],
      strengthVideos[4],
      strengthVideos[5],
      strengthVideos[6],
      strengthVideos[7],
      videos[11],
      videos[12],
      videos[13],
    ];
    const validateResults = [];
    for (let i = 0; i < needsValidation.length; i++) {
      videoValidation(needsValidation[i])
        .then((res) => {
          validateResults.push({
            videoLink: needsValidation[i].videoLink,
            order: i,
            validated: res,
          });
        })
        .catch((e) =>
          validateResults.push({
            videoLink: needsValidation[i].videoLink,
            order: i,
            validated: e,
          })
        );
    }
    promiseBufferStrength(validateResults);
  };

  // Buffer to ensure promises resolve and then start the class
  const promiseBuffer = (results) => {
    const validatedSequence = [];
    if (results.length === 14 && !start) {
      results.forEach((result, i) => {
        result.validated
          ? validatedSequence.push(results[i])
          : validatedSequence.push(updateInvalidLink(results[i]));
      });
      const sortedSequence = validatedSequence.sort(
        (a, b) => a.order - b.order
      );
      setSequence(sortedSequence);
      setStart(true);
    } else {
      setTimeout(() => {
        promiseBuffer(results);
      }, 1000);
    }
  };

  const promiseBufferMashup = (results) => {
    const validatedSequence = [];
    if (results.length === 7 && !start) {
      results.forEach((result, i) => {
        result.validated
          ? validatedSequence.push(results[i])
          : validatedSequence.push(updateInvalidMashupLink(results[i]));
      });
      const sortedSequence = validatedSequence.sort(
        (a, b) => a.order - b.order
      );
      setSequence(sortedSequence);
      setStart(true);
    } else {
      setTimeout(() => {
        promiseBufferMashup(results);
      }, 1000);
    }
  };

  const promiseBufferStrength = (results) => {
    const validatedSequence = [];
    if (results.length === 14 && !start) {
      results.forEach((result, i) => {
        result.validated
          ? validatedSequence.push(results[i])
          : validatedSequence.push(updateInvalidStrengthLink(results[i], strengthClass[0]?.groupId));
      });
      const sortedSequence = validatedSequence.sort(
        (a, b) => a.order - b.order
      );
      setSequence(sortedSequence);
      setStart(true);
    } else {
      setTimeout(() => {
        promiseBufferStrength(results);
      }, 1000);
    }
  };

  // If no class is detected as loaded in memory, load the class. If there is a class in memory but it has been stopped, handle stop
  const manualMode = () => {
    if (sequence.length === 0 && newScreen?.classStart) {
      loadClass();
    } else if (workout && sequence.length > 0 && !newScreen?.classStart) {
      handleStop();
    }
  };

  // If next scheduled class time has started, load class. If the class is over, handle stop
  const automaticMode = () => {
    if (nextClassTime) {
      const timeZone = newScreen?.location?.timeZone || "America/New_York";
      const timeDiff =
        timeDiffToLocal(nextClassTime, timeZone) + countDownMinutes;
      if (timeDiff >= 0 && timeDiff < gracePeriodMinutes) {
        if (!start) {
          console.log("starting the next class...");
          loadClass();
        }
      } else if (workout && sequence.length > 0) {
        handleStop();
      }
    }
  };

  // Check for type of class to load and then start it
  const loadClass = () => {
    if (type?.selection === "Normal" || screenDetails.supportsMct !== true) {
      startClass();
    } else if (type?.selection === "Mashup") {
      startMashupClass();
    } else if (type?.selection === "Strength") {
      startStrengthClass();
    } else {
      startClass();
    }
  };

  // Render the combo text during the combination rounds
  const comboEffect = () => {
    setComboStart(true);
    comboInterval.current = setTimeout(() => {
      setComboStart(false);
    }, 44000);
  };

  useEffect(() => {
    if (!Object.keys(timeObj).length) return;
    // we want to start the class if we're still within the grace period
    const filteredClasses = scheduleObj[timeObj?.today].filter(
      (classObj) =>
        addToTime(classObj.class_time, gracePeriodMinutes) > timeObj?.local_time
    );

    setNextClassTime(filteredClasses[0]?.class_time || null);
    // eslint-disable-next-line
  }, [screen, schedule, scheduleObj, timeObj, newScreen, start]);

  useEffect(() => {
    if ((!schedule || !Object.keys(schedule).length) && newScreen) {
      getLocationSchedule(newScreen?.location?.urlSlug);
      return;
    }

    if (!Object.keys(timeObj).length && newScreen) {
      // build the time object
      const datetime_str = new Date().toLocaleString(
        newScreen?.location?.language || "en-US",
        {
          timeZone: newScreen?.location?.timeZone || "America/New_York",
        }
      );
      const today = weekDays[(new Date(datetime_str).getDay() + 6) % 7];

      // create new Date object
      const date_local = new Date(datetime_str);

      // get hours and minutes with leading zeroes if needed
      let hour = ("0" + date_local.getHours()).slice(-2);
      let minute = ("0" + date_local.getMinutes()).slice(-2);

      // time in hh:mm format
      const local_time = hour + ":" + minute;

      setTimeObj({
        today: today,
        local_time: local_time,
      });
    }

    setScheduleObj({
      ...handleSchedule(schedule),
    });
    // eslint-disable-next-line
  }, [schedule, screen, newScreen, start]);

  useEffect(() => {
    if (!workout) getCurrentRoundWorkout(1);
    if (!newScreen) setNewScreen(screen);
    // eslint-disable-next-line
  }, [workout, loading, , newScreen]);

  // Check for manual mode or automatic mode and run start detected mode
  const handleModes = () => {
    if (newScreen && workout && newScreen.automaticMode !== true) {
      manualMode();
    } else if (newScreen.automaticMode && nextClassTime) {
      automaticMode();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      sendScreenStatus(start, screen.automaticMode).then((screenUpdates) => {
        compareScreens(newScreen, screenUpdates);
      });

      if (!start) {
        handleModes();
      }
    }, 30 * 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  });

  // Compare screen in memory vs screen on server
  const compareScreens = (local, latest) => {
    if (
      latest?.classStart === false &&
      start &&
      latest?.automaticMode === false
    )
      handleStop();
    if (
      local?.automaticMode !== latest?.automaticMode ||
      local?.classStart !== latest?.classStart ||
      local?.location?.alternateCountdown !==
        latest?.location?.alternateCountdown
    ) {
      setNewScreen(latest);
      setScreenDetails({
        countdown: latest?.location?.alternateCountdown
          ? TEN_SECONDS
          : FIVE_MINUTES,
        supportsMct: latest?.location?.mctEnabled,
      });
      setCountDownMinutes(latest?.location?.alternateCountdown ? 0.17 : 5);
    } else {
      return false;
    }
  };

  const startPressTimer = () => {
    timeoutRef.current = setTimeout(() => {
      handleCleanup();
    }, LONG_PRESS_DURATION);
  };

  const cancelPressTimer = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  };

  // Unmount class and go back to class select screen
  const handleCleanup = () => {
    handleStop();
    setType({ selection: null });
  };

  // Clean up state
  const handleStop = () => {
    comboInterval.current = null;
    setSequence([]);
    setStart(false);
    setComboStart(false);
    tearDownPlayer();
    setNextClassTime("");
    setTimeObj({});
    setScheduleObj({
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: [],
    });
  };

  // Initialize the vlite player
  const initializePlayer = () => {
    classPlayer = new Vlitejs("#player", {
      options: {
        controls: true,
        autoplay: true,
        playPause: false,
        progressBar: true,
        time: false,
        volume: false,
        fullscreen: false,
        bigPlay: false,
        playsinline: true,
        loop: false,
        muted: false,
        autoHide: true,
        autoHideDelay: true,
      },
      onReady: (player) => {
        player.on("play", () => {
          player.unMute();
        });
        player.on("ended", () => {
          transitionVideo();
        });
        player.on("pause", () => {
          player.play();
        });
      },
    });
  };

  // Remove all references to the vlite player and remove the wrapper from the dom
  const tearDownPlayer = () => {
    const playerElement = document.querySelector("#player");
    const wrapper = playerElement && playerElement.closest(".v-vlite");
    if (classPlayer) {
      classPlayer.destroy();
      classPlayer = null;
    }
    if (wrapper && playerElement) {
      wrapper.parentNode.insertBefore(playerElement, wrapper);
      wrapper.remove();
    }
  };

  useEffect(() => {
    if (sequence && sequence.length > 0 && !classPlayer) initializePlayer();
    //eslint-disable-next-line
  }, [start]);

  useEffect(() => {
    return () => {
      clearTimeout(comboInterval.current);
      clearSchedule();
      handleCleanup();
    };
    //eslint-disable-next-line
  }, []);

  return (
    <div
      className="ClassContainer"
      onMouseDown={startPressTimer}
      onMouseUp={cancelPressTimer}
      onMouseLeave={cancelPressTimer}
      onTouchStart={startPressTimer}
      onTouchEnd={cancelPressTimer}
      onTouchCancel={cancelPressTimer}
    >
      <video
        src={
          start && sequence && sequence.length > 0 ? sequence[0]?.videoLink : ""
        }
        id="player"
        className="Class"
        controlsList="nodownload"
      ></video>

      {comboStart &&
        sequence &&
        sequence.length > 0 &&
        type?.selection !== "Mashup" &&
        type?.selection !== "Strength" && (
          <div id="combo-overlay-container">
            <h1 id="combo-overlay-text">COMBO # {sequence[0]?.order - 2}</h1>
          </div>
        )}
      {!start && (
        <>
          <img id="next-class-img" src={nextClass} alt="class-start"></img>
          <div id="next-class-container">
            {newScreen?.automaticMode ? (
              <>
                {nextClassTime ? (
                  <>
                    <h1 id="next-class-header">Next class starts at</h1>
                    <h2 id="next-class-time">
                      {nextClassTime && convertTime(nextClassTime, 12)}
                    </h2>
                  </>
                ) : (
                  <h1 id="next-class-header">
                    No more classes
                    <br />
                    scheduled for today.
                  </h1>
                )}
              </>
            ) : (
              <>
                <h1 id="welcome-to-ilkb-header">
                  Welcome to iLoveKickboxing,
                  <br />
                  {newScreen.location?.name}!
                </h1>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Class;
